import axios from 'axios'

import { IsDev } from '../helpers/build'
import {asyncTimeout} from '../helpers/utils';

const mockData = () => require('../mocks/conditions').default
export const FETCH_CONDITIONS_ENDPOINT = window?.drupalSettings?.rooms?.rates?.conditionsURL
export default async function (params) {
  if (IsDev) {
    console.info('%c GET /conditions, paramsToSend: ', 'color: #67a9ad; font-weight: bold;', params)
    await asyncTimeout(1)
    return {data: mockData()}
  }

  return await axios.get(FETCH_CONDITIONS_ENDPOINT, { params })
}
